import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarComponent } from '@shared/components/snack-bar/snack-bar.component';
import { SnackBarData } from '@shared/interfaces/snack-bar';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SnackBarService {
  private matSnackBarRef: MatSnackBarRef<unknown> | null = null;

  constructor(
    private matSnackBarService: MatSnackBar,
    private translateService: TranslateService
  ) {}

  error(message: string, duration?: number): void {
    this.open({ message, type: 'error' }, duration);
  }

  errorFromKey(messageKey: string): void {
    this.error(this.translateService.instant(messageKey));
  }

  close(): void {
    if (this.matSnackBarRef) {
      this.matSnackBarRef.dismiss();
    }
  }

  private open(data: SnackBarData, duration = 3000) {
    const matSnackBarRef = this.matSnackBarService.openFromComponent(
      SnackBarComponent,
      {
        duration,
        data,
      }
    );

    this.matSnackBarRef = matSnackBarRef;

    matSnackBarRef
      .afterDismissed()
      .pipe(filter(() => this.matSnackBarRef === matSnackBarRef))
      .subscribe(() => {
        this.matSnackBarRef = null;
      });
  }
}
